import { ScatterplotLayer, ScatterplotLayerProps } from "@deck.gl/layers"
import { DataFilterExtension } from "@deck.gl/extensions"
import { FlightPoint } from "./FlightsLayer.class"

type _FlightImagePointsLayerProps = {
    getFilterValue: () => number
    filterRange?: [number, number]
}

type FlightImagePointsLayerProps<DataType = FlightPoint> = ScatterplotLayerProps<DataType> &
    _FlightImagePointsLayerProps

const defaultProps = {
    filled: true,
    stroked: true,
    pickable: true,
    radiusScale: 1,
    opacity: 1,
    radiusUnits: "meters" as const,
    lineWidthUnits: "pixels" as const,
    lineWidthMinPixels: 1,
    lineWidthMaxPixels: 1,
    extensions: [new DataFilterExtension({ filterSize: 1 })],
    filterRange: [1, 1],
    getRadius: () => 8,
    antialiasing: false,
}

export default class FlightImagePointsLayer<
    DataType = FlightPoint,
    ExtraPropsType extends object = FlightImagePointsLayerProps,
> extends ScatterplotLayer<DataType, ExtraPropsType> {
    static defaultProps = defaultProps
    static layerName = "FlightImagePoints"
}
